var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-card-box"},[_c('div',{staticClass:"chat-card"},[_c('div',{staticClass:"chat-text"},[_vm._v(" "+_vm._s(_vm.cardData.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }